// Module Class
// A common class framework for modules
// 
//

JLM.MD.Module = function() {
	
	// Variables
	var INSTANCE = {};
	var events = {};
	
	
	// Dispatch Event
	// 
	INSTANCE.dispatchEvent = function( eventtype, args ) {
		if ( events[ eventtype ] ) {
			if ( args === null || args === undefined ) {
				args = [];
			} else if ( args instanceof Array !== true ) {
				args = [ args ];
			}
			var i = events[ eventtype ].length; while( i-- ) {
				events[ eventtype ][i].apply( INSTANCE, args );
			}
		}
		return INSTANCE;
	};
	
	
	// On - Attach events
	// 
	INSTANCE.on = function( eventtype, method ) {
		// If multiple events
		if ( typeof eventtype === 'string' ) {
			var types = eventtype.split(' ');
			eventtype = ( types.length > 1 ) ? types : eventtype;
		}
		if ( eventtype instanceof Array ) {
			for( var index in eventtype ) {
				INSTANCE.on( eventtype[ index ], method );
			}
			return INSTANCE;
		}
		
		// Listen for this event
		if ( !events[ eventtype ] ) {
			events[ eventtype ] = [];
		}
		events[ eventtype ].push( method );
		
		return INSTANCE;
	};
	
	
	// Off - Remove events
	// 
	INSTANCE.off = function( eventtype, method ) {
		// If multiple events
		if ( typeof eventtype === 'string' ) {
			var types = eventtype.split(' ');
			eventtype = ( types.length > 1 ) ? types : eventtype;
		}
		if ( eventtype instanceof Array ) {
			for( var index in eventtype ) {
				INSTANCE.off( eventtype[ index ], method );
			}
			return INSTANCE;
		}
		
		// Stop listening for this event
		if ( events[ eventtype ] ) {
			var i = events[ eventtype ].length; while( i-- ) {
				if ( events[ eventtype ][i] === method ) {
					events[ eventtype ].splice(i, 1);
					break;
				}
			}
		}
		return INSTANCE;
	};
	
	return INSTANCE;
		
};

